import { SearchCombobox } from '@zarya/ui';
import { t } from '@app/i18n';
import { stateLabel, ROLES, roleLabel, type StateFilter, type Role } from './UserModel';

export interface UsersFiltersProps {
  role: Role | null;
  state: StateFilter;
  onPapelChange: (role: Role | null) => void;
  onEstadoChange: (state: StateFilter) => void;
}

/**
 * Filtros da grade de T22 (FR-106): caixas com busca de papel e de estado, como as de T4 e T6. O PRD §4 pedia
 * pílulas; desde o aim-pjv (decisão do mrolim, 10/10/2026) filtro de escolha entre opções é caixa com busca. A busca
 * por nome/e-mail é a da própria `DataTable`.
 *
 * O estado é um filtro de três valores porque o contrato distingue "só ativos", "só desativados" e "todos": «Ativos»
 * é o padrão, e o «×» da caixa volta a ele. Por isso o «×» só aparece fora do padrão.
 */
export function UsersFilters({ role, state, onPapelChange, onEstadoChange }: UsersFiltersProps) {
  return (
    <>
      <SearchCombobox
        label={t('users.filters.role')}
        placeholder={t('users.filters.role.placeholder')}
        searchPlaceholder={t('users.filters.role.searchPlaceholder')}
        size="sm"
        clearable
        options={[
          { value: '', label: t('users.filters.role.all') },
          ...ROLES.map((p) => ({ value: p, label: roleLabel(p) })),
        ]}
        value={role}
        onChange={(valor) => onPapelChange((valor as Role | null) || null)}
      />
      <SearchCombobox
        label={t('users.filters.state')}
        searchPlaceholder={t('users.filters.state.searchPlaceholder')}
        size="sm"
        clearable={state !== 'ativos'}
        options={(['ativos', 'desativados', 'todos'] as const).map((e) => ({
          value: e,
          label: stateLabel(e),
        }))}
        value={state}
        onChange={(valor) => onEstadoChange((valor as StateFilter | null) || 'ativos')}
      />
    </>
  );
}
